import styled from 'styled-components';
import React from 'react';
import { SectionParent, BlueButton } from '../../StyledComponents';

import HeroBgMobile from '../../../assets/v2/Hardware/hardware-mobile.jpg';
import { navigate } from 'gatsby';
import { Title } from '../HomePage/HomepageSectionOne';
import Traditonal from '../../../assets/v2/DigitalSignage/traditional.png';
import Interactive from '../../../assets/v2/DigitalSignage/interactive.png';
import Context from '../../../assets/v2/DigitalSignage/context.png';

const SectionOne = styled.div`
  background-repeat: no-repeat;
  padding-bottom: 5rem !important;
  background: #f9fffd;
  @media (max-width: 768px) {
    background-size: cover;
    padding-top: 0rem !important;
  }
  width: 100%;
  display: grid;
`;
const BgContainer = styled(SectionParent)`
  background: #f9fffd;
  padding-top: 8rem !important;
  padding-left: 0;
  padding-right: 0%;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-bottom: 0rem;
    padding-left: 0;
    padding-right: 0%;
  }
  @media (max-width: 1250px) and (min-width: 768px) {
    padding-bottom: 0rem;
  }
  @media (max-width: 768px) {
    background-size: cover;
    padding-top: 8rem !important;
    /* background-image: url(${HeroBgMobile}); */
  }
  @media (max-width: 520px) {
    padding-top: 8rem !important;
    padding-bottom: 0;
  }
  width: 100%;
  display: grid;
`;

const SectionItemContainer = styled.div`
  display: grid;
  justify-items: center;
  @media (max-width: 520px) {
    padding-left: 0rem;
  }
`;

const SectionOneTitle = styled(Title)`
  color: #151828;
  text-align: center;
  margin-bottom: 0.3rem;
  @media (max-width: 768px) {
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    margin-left: 0;
    padding: 0 2rem;
  }
  @media (max-width: 400px) {
    padding: 0;
  }
`;

const GridRight = styled.div`
  grid-column: span 2;
  padding-right: 8rem;
  /* padding-left: 3rem; */
  margin-top: 3rem;
  align-content: center;
  display: grid;
  @media (max-width: 1100px) {
    margin-top: 7rem;
  }
  @media (max-width: 768px) {
    grid-column: span 3;
    padding-right: 0rem;
    margin-top: 0rem;
    padding-left: 0rem;
    min-height: 15rem;
  }
`;

const HeroSubTitle = styled(SectionParent)`
  padding-top: 1.5rem;
  /* margin-left: 3rem;
  margin-right: 3rem; */
  padding: 0 14rem;
  width: 70%;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  /* text-shadow: 0px 1px #000000; */
  letter-spacing: normal;
  color: #151828;
  text-align: center;
  @media (max-width: 1440px) and (min-width: 780px) {
    padding: 0rem 10rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    width: 100%;
    padding-top: 0.5rem;
    line-height: 1.5;
    margin-bottom: -1rem;
    margin-left: 0;
  }
`;

const BlueButtonWrapper = styled.div`
  margin: 1rem 0;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;

const BlueButtonNew = styled(BlueButton)`
  background-color: #725cbd;
  color: #ffffff;
`;
const HeroImgContainerLeft = styled.img`
  width: 100%;
  grid-column: span 1;
  justify-self: center;
  @media (max-width: 768px) {
    width: 85%;
  }
  @media (max-width: 520px) {
    width: 90%;
  }
`;
const HeroImgContainer = styled(SectionParent)`
  /* height: 19.7rem; */
  /* padding: 2rem 0rem; */
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding-bottom: 0;
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
const SubTitle = styled.div`
  padding-bottom: 2rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 21px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.52;
  letter-spacing: normal;
  color: #151828;
  text-align: center;
  @media (max-width: 520px) {
    padding-top: 0.5rem;
    margin-bottom: -1rem;
  }
`;
export default class DigitalSectionOne extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }
  render() {
    return (
      <div>
        <BgContainer>
          <SectionOneTitle>
            Create engaging, immersive experiences at scale
          </SectionOneTitle>
          <SubTitle>
            You need agility and control over your Digital signage device.{' '}
          </SubTitle>
          <HeroImgContainer>
            <HeroImgContainerLeft alt="EsperHardware" src={Traditonal} />
            <HeroImgContainerLeft alt="EsperHardware" src={Interactive} />
            <HeroImgContainerLeft alt="EsperHardware" src={Context} />
          </HeroImgContainer>
        </BgContainer>
        <SectionOne>
          <SectionItemContainer>
            <BlueButtonWrapper>
              <BlueButtonNew
                id="digital_signage__signup"
                onClick={() => navigate('/signup')}
              >
                Sign up
              </BlueButtonNew>
            </BlueButtonWrapper>
            <HeroSubTitle style={{ paddingTop: '1rem' }}>
              Esper is the first-ever suite of solutions designed to simplify
              the creation, configuration and deployment of digital signage
              solutions. <br />
              <br />
              It’s easier than ever to gain total control of your Android
              signage. You’re free to focus on what really matters, like
              delivering the highest-converting, most engaging solutions at
              scale. <br />
              <br />
              <span style={{ fontWeight: 'bold' }}>
                Your digital signage vision is about to become a reality.{' '}
              </span>
            </HeroSubTitle>
          </SectionItemContainer>
        </SectionOne>
      </div>
    );
  }
}
